/**
 * budget-guard — 일일 Assistant 예산 가드
 *
 * 정책 (docs/specs/promptops.md §11.2):
 *  - 사용량 80% 초과 → UI 경고 + Haiku fallback 자동 전환
 *  - 사용량 100% 초과 → 호출 차단 (owner 수동 승인 필요)
 *  - 기본 예산 $15/day (ASSISTANT_DAILY_BUDGET_USD)
 */

export const FALLBACK_THRESHOLD = 0.7;
export const NOTIFY_THRESHOLD = 0.8;
export const BLOCK_THRESHOLD = 1.0;

export interface BudgetState {
  spentUsd: number;
  limitUsd: number;
  ratio: number;
  remainingUsd: number;
  /** Sonnet → Haiku 자동 전환 필요 여부 (70% 이상) */
  forceFallback: boolean;
  /** 80% 경고 표시 여부 */
  notify: boolean;
  /** 호출 차단 여부 (100% 초과) */
  blocked: boolean;
}

export function checkBudget(spentUsd: number, limitUsd: number): BudgetState {
  const safeLimit = Math.max(limitUsd, 0);
  const ratio = safeLimit > 0 ? spentUsd / safeLimit : 0;
  return {
    spentUsd,
    limitUsd: safeLimit,
    ratio,
    remainingUsd: Math.max(0, safeLimit - spentUsd),
    forceFallback: ratio >= FALLBACK_THRESHOLD,
    notify: ratio >= NOTIFY_THRESHOLD,
    blocked: ratio >= BLOCK_THRESHOLD,
  };
}

/** UI용 short status 라벨 */
export function budgetLabel(state: BudgetState): 'ok' | 'fallback' | 'warn' | 'blocked' {
  if (state.blocked) return 'blocked';
  if (state.notify) return 'warn';
  if (state.forceFallback) return 'fallback';
  return 'ok';
}
